class Clock {
  // eslint-disable-next-line no-useless-constructor
  constructor() {
    // do nothing
  }

  setup(totalWatchTime) {
    this.totalSeconds = parseInt(totalWatchTime, 10);
    this.started = false;
    this.interval = null;
  }

  setSeconds = (totalWatchTime) => {
    this.totalSeconds = parseInt(totalWatchTime, 10) || 0;
  };

  start = (callback) => {
    this.started = true;
    this.interval = setInterval(callback, 1000);
  };

  pause = () => {
    clearInterval(this.interval);
    delete this.interval;
  };

  resume = (callback) => {
    if (!this.interval) this.start(callback);
  };

  end = () => {
    this.totalSeconds = 0;
    this.started = false;
    clearInterval(this.interval);
    delete this.interval;
  };
}

export default Clock;
